module.exports = __webpack_public_path__ + "img/40_69_000_090.728c1177.jpg";